(function () {
  var rituals = document.querySelectorAll('.riwayat-ritual');
  if (!rituals.length) return;

  rituals.forEach(function (ritual) {
    var steps = Array.prototype.slice.call(ritual.querySelectorAll('.riwayat-ritual__step'));
    if (!steps.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var index = steps.indexOf(entry.target);
          if (index === -1) return;
          entry.target.classList.toggle('is-active', entry.isIntersecting);
          if (entry.isIntersecting) {
            ritual.style.setProperty('--ritual-progress', index / (steps.length - 1));
          }
        });
      },
      { threshold: 0.6 }
    );

    steps.forEach(function (step) {
      observer.observe(step);
    });
  });
})();
